var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndividuals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M23.3615 20.96C23.0214 20.7638 22.5999 20.8096 22.2777 21.034C20.4974 22.2733 18.3336 23 16 23C13.6664 23 11.5025 22.2733 9.7223 21.0339C9.40003 20.8096 8.97858 20.7638 8.63843 20.96C6.40524 22.2484 4.50383 24.1334 3.13495 26.5C3.04723 26.6519 3.00102 26.8243 3.00098 26.9997C3.00093 27.1752 3.04705 27.3475 3.13469 27.4995C3.22234 27.6515 3.34843 27.7778 3.50031 27.8656C3.65219 27.9535 3.8245 27.9998 3.99995 28H28C28.1755 28 28.348 27.9538 28.5001 27.8661C28.6521 27.7783 28.7784 27.652 28.8662 27.5C28.9538 27.3478 28.9998 27.1753 28.9996 26.9998C28.9993 26.8243 28.9529 26.6519 28.865 26.5C27.4961 24.1334 25.5947 22.2484 23.3615 20.96Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 12,
    r: 9,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndividuals);
export default __webpack_public_path__ + "static/media/individuals.657cf777550986dd80f54639b6045238.svg";
export { ForwardRef as ReactComponent };